export default __webpack_public_path__ + "static/media/INKL.b99664d5.png";